import { render, staticRenderFns } from "./ArticleAnalysis.vue?vue&type=template&id=03c2cb81&scoped=true"
import script from "./ArticleAnalysis.vue?vue&type=script&lang=js"
export * from "./ArticleAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ArticleAnalysis.vue?vue&type=style&index=0&id=03c2cb81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c2cb81",
  null
  
)

export default component.exports